import { deepCopy } from '.'

const defLineProps = {
  six: [
    { target: [1,1,1,1,1,0],       point: [0,0,0,0,0,1] },
    { target: [1,1,1,1,0,1],       point: [0,0,0,0,1,0] },
    { target: [1,1,1,0,1,1],       point: [0,0,0,1,0,0] },
    { target: [1,1,0,1,1,1],       point: [0,0,1,0,0,0] },
    { target: [1,0,1,1,1,1],       point: [0,1,0,0,0,0] },
    { target: [0,1,1,1,1,1],       point: [1,0,0,0,0,0] },
  ],
  five: [
    { target: [1,1,1,1,0],         point: [0,0,0,0,1] },
    { target: [1,1,1,0,1],         point: [0,0,0,1,0] },
    { target: [1,1,0,1,1],         point: [0,0,1,0,0] },
    { target: [1,0,1,1,1],         point: [0,1,0,0,0] },
    { target: [0,1,1,1,1],         point: [1,0,0,0,0] }
  ],
  doubleFour: [
    { target: [1,1,1,0,0,0,1,1,1], point: [0,0,0,0,1,0,0,0,0] },
    { target: [1,1,0,0,1,0,1,1],   point: [0,0,0,1,0,0,0,0]   },
    { target: [1,1,0,1,0,0,1,1],   point: [0,0,0,0,1,0,0,0]   },
    { target: [1,0,0,1,1,0,1],     point: [0,0,1,0,0,0,0]     },
    { target: [1,0,1,0,1,0,1],     point: [0,0,0,1,0,0,0]     },
    { target: [1,0,1,1,0,0,1],     point: [0,0,0,0,1,0,0]     },
  ],
  four: [
    { target: [1,1,1,0,0],         point: [0,0,0,1,1] },
    { target: [1,1,0,1,0],         point: [0,0,1,0,1] },
    { target: [1,1,0,0,1],         point: [0,0,1,1,0] },
    { target: [1,0,1,1,0],         point: [0,1,0,0,1] },
    { target: [1,0,1,0,1],         point: [0,1,0,1,0] },
    { target: [1,0,0,1,1],         point: [0,1,1,0,0] },
    { target: [0,1,1,1,0],         point: [1,0,0,0,1] },
    { target: [0,1,1,0,1],         point: [1,0,0,1,0] },
    { target: [0,1,0,1,1],         point: [1,0,1,0,0] },
    { target: [0,0,1,1,1],         point: [1,1,0,0,0] },
  ],
  three: [
    { target: [0,1,1,0,0,0],       point: [0,0,0,1,1,0] },
    { target: [0,1,0,1,0,0],       point: [0,0,1,0,1,0] },
    { target: [0,1,0,0,1,0],       point: [0,0,1,1,0,0] },
    { target: [0,0,1,1,0,0],       point: [0,1,0,0,1,0] },
    { target: [0,0,1,0,1,0],       point: [0,1,0,1,0,0] },
    { target: [0,0,0,1,1,0],       point: [0,1,1,0,0,0] }
  ]
}

const defRotate = ['0', '45', '90', '315']
const defLineName = ['six', 'five', 'doubleFour', 'four', 'three']

class RenjuEngine {
  constructor(arrayBoard, threeList) {
    this.init(arrayBoard, threeList)
  }

  init(arrayBoard, threeList) {
    var x, y
    this.boardWidth = 15
    this.root = true

    if (arrayBoard === undefined) {
      this.arrayBoard = new Array(this.boardWidth * this.boardWidth)
      for (y = 0; y < this.boardWidth; y++) {
        for (x = 0; x < this.boardWidth; x++) {
          this.arrayBoard[x + y * this.boardWidth] = {
            x, y, color: 0, forbidden: false, doubleThree: false,
            '0': '', '45': '', '90': '', '315': ''
          }
        }
      }
    }
    else {
      this.arrayBoard = deepCopy(arrayBoard)
    }

    if (threeList === undefined) {
      this.threeList = []
    }
    else {
      this.threeList = threeList.map(threeLine => {
        return {
          threePos: this.arrayBoard[threeLine.threePos.x + threeLine.threePos.y * this.boardWidth],
          stonePos: threeLine.stonePos.map(cell => { return this.arrayBoard[cell.x + cell.y * this.boardWidth] }),
          straightFourPos: threeLine.straightFourPos.map(cell => { return this.arrayBoard[cell.x + cell.y * this.boardWidth] }),
          rotate: threeLine.rotate
        }
      })
    }
  }

  setMoves(moves) {
    if (moves === undefined) {
      return
    }
    this.convertToArrayBoard(moves)
  }

  update(x, y, color) {
    var row
    this.arrayBoard[x + y * this.boardWidth].color = color
    defRotate.forEach(rotate => {
      row = this.getRotateRow(this.arrayBoard, x, y, rotate)
      row.forEach(cell => cell[rotate] = '')
      defLineName.forEach(lineName => {
        defLineProps[lineName].forEach(lineProps => {
          this.checkLineForRow(rotate, lineName, lineProps, row)
        })
      })      
      row.forEach(cell => { this.setForbiddenAndDoubleThree(cell) })
    })
  }

  setForbiddenAndDoubleThree(cell) {
    var lineCount = { 'six': 0, 'five': 0, 'four': 0, 'doubleFour': 0, 'three': 0 }
    defRotate.forEach(rotate => {
      defLineName.forEach(lineName => {
        lineCount[lineName] = cell[rotate] === lineName ? lineCount[lineName] + 1 : lineCount[lineName]
      })
    })
    cell.forbidden = Boolean(lineCount['five'] === 0 && (lineCount['six'] >= 1 || lineCount['four'] >= 2 || lineCount['doubleFour'] >= 1))
    cell.doubleThree = Boolean(lineCount['three'] >= 2)
  }

  convertToArrayBoard(moves) {
    moves.forEach(move => {
      if (move.color === null) {
        return
      }
      this.arrayBoard[move.x + move.y * this.boardWidth].color =
        move.color === 'black' ? 1 : move.color === 'white' ? 2 : 0
    })
  }

  checkLine() {
    var arrayBoard
    defRotate.forEach(rotate => {
      arrayBoard = this.rotateArrayBoard(this.arrayBoard, rotate)
      defLineName.forEach(lineName => {
        defLineProps[lineName].forEach(lineProps => {
          arrayBoard.forEach(row => {
            this.checkLineForRow(rotate, lineName, lineProps, row)
          })
        })
      })
    })
    this.arrayBoard.forEach(cell => { this.setForbiddenAndDoubleThree(cell) })
    if (this.root === true) {
      this.checkThreeAll()
    }
  }

  checkLineForRow(rotate, lineName, lineProps, row) {
    var index, stonePos
    if (row.length < lineProps.target.length) {
      return
    }
    for (index = 0; index <= row.length - lineProps.target.length; index++) {
      stonePos = []
      if (this.compareLineAndRow(row, index, stonePos, lineProps, lineName)) {
        this.setLineName(row, lineProps, lineName, index, stonePos, rotate)
      }
    }
  }

  
  compareLineAndRow(row, index, stonePos, lineProps, lineName) {
    return row.slice(index, index + lineProps.target.length)
    .every((cell, rIndex) => {
      if (cell.color === 1 && cell.color === lineProps.target[rIndex]) {
        stonePos.push(cell)
      }
      return cell.color === lineProps.target[rIndex]
    }) && (lineName === 'six' || (
      !(index > 0 && row[index - 1].color === 1) &&
      !(index + lineProps.target.length < row.length && row[index + lineProps.target.length].color === 1)
    ))

  }

  setLineName(row, lineProps, lineName, index, stonePos, rotate) {
    var threeLine, sfIndex
    lineProps.point.forEach((cell, pIndex) => {
      if (cell !== 1) {
        return
      }
      if (lineName === 'three') {
        sfIndex = lineProps.point.findIndex((lineCell, idx) => { return lineCell === 1 && pIndex !== idx })
        threeLine = this.threeList.find(ln => {
          return ln.threePos === row[index + pIndex] &&
                 stonePos.every(stone => ln.stonePos.some(st => st === stone))
        })
        if (threeLine === undefined) {
          this.threeList.push({
            threePos: row[index + pIndex],
            stonePos,
            straightFourPos: [row[index + sfIndex]],
            rotate
          })
        }
        else {
          threeLine.straightFourPos.push(row[index + sfIndex])
        }
      }
      if (row[index + pIndex][rotate] === '') {
        row[index + pIndex][rotate] = lineName
      }
    })
  }

  checkThreeAll() {
    var renjuEngine, threeCount, fiveCount
    this.threeList.forEach(threeLine => {
      // if (threeLine.threePos.doubleThree === false) {
      //   return
      // }
      if (threeLine.straightFourPos.every(pos => {
        let result
        renjuEngine = new RenjuEngine(this.arrayBoard, this.threeList)
        renjuEngine.update(threeLine.threePos.x, threeLine.threePos.y, 1)
        result = renjuEngine.checkForbidden(pos.x, pos.y)
        return result
      })) {
        threeLine.threePos[threeLine.rotate] = ''
      }
    })
    this.arrayBoard.forEach(cell => {
      fiveCount = 0
      threeCount = 0
      defRotate.forEach(rotate => {
        fiveCount = cell[rotate] === 'five' ? fiveCount + 1 : fiveCount
        threeCount = cell[rotate] === 'three' ? threeCount + 1 : threeCount
      })
      cell.forbidden = Boolean(fiveCount === 0 && threeCount >= 2) ? true : cell.forbidden
    })
  }

  checkForbidden(x, y) {
    var renjuEngine, target, threeCount
    target = this.arrayBoard[x + y * this.boardWidth]
    if (target.forbidden === true){
      return true
    }
    if (target.doubleThree) {
      renjuEngine = new RenjuEngine(this.arrayBoard, this.threeList)
      renjuEngine.update(x, y, 1)
      threeCount = 0
      this.threeList.forEach(threeLine => {
        if (threeLine.threePos.x !== x || threeLine.threePos.y !== y) {
          return
        }
        if (!threeLine.straightFourPos.every(pos => {
          return renjuEngine.checkForbidden(pos.x, pos.y)
        })) {
          threeCount = threeCount + 1
        }
      })
      return threeCount >= 2
    }
    else {
      return false
    }
  }

  rotateArrayBoard(arrayBoard, deg = '0') {
    var lines, x, y
    lines = []
    switch(deg) {
      case '0':
        for (y = 0; y < this.boardWidth; y++) {
          lines.push(arrayBoard.slice(y * this.boardWidth, (y + 1) * this.boardWidth))
        }
        break
      case '45':
        for (y = 0; y < this.boardWidth * 2; y++) {
          lines.push([])
          for (x = 0; x < y + 1 && x < this.boardWidth; x++) {
            if (x + (y - x) * this.boardWidth >= this.boardWidth * this.boardWidth) {
              continue
            }
            lines[y].push(this.arrayBoard[x + (y - x) * this.boardWidth])
          }
        }
        break
      case '90':
        for (x = 0; x < this.boardWidth; x++) {
          lines.push([])
          for (y = this.boardWidth - 1; y >= 0; y--) {
            lines[x].push(this.arrayBoard[x + y * this.boardWidth])
          }
        }
        break
      case '315':
        for (x = 0; x < this.boardWidth * 2; x++) {
          lines.push([])
          for (y = 0; y < x + 1 && y < this.boardWidth; y++) {
            if (this.boardWidth - 1 - x + y < 0) {
              continue
            }
            lines[x].push(this.arrayBoard[this.boardWidth - 1 - x + y + y * this.boardWidth])
          }
        }
        break
      default: 
        break
    }
    return lines
  }

  getRotateRow(arrayBoard, targetX, targetY, deg = '0') {
    var lines, x, y
    lines = []
    switch(deg) {
      case '0':
        lines = arrayBoard.slice(targetY * this.boardWidth, (targetY + 1) * this.boardWidth)
        break
      case '45':
        y = targetY + targetX
        for (x = 0; x < y + 1 && x < this.boardWidth; x++) {
          if (x + (y - x) * this.boardWidth >= this.boardWidth * this.boardWidth) {
            continue
          }
          lines.push(this.arrayBoard[x + (y - x) * this.boardWidth])
        }
        break
      case '90':
        for (y = this.boardWidth - 1; y >= 0; y--) {
          lines.push(this.arrayBoard[targetX + y * this.boardWidth])
        }
        break
      case '315':
        x = this.boardWidth - 1 - targetX  + targetY
        for (y = 0; y < x + 1 && y < this.boardWidth; y++) {
          if (this.boardWidth - 1 - x + y < 0) {
            continue
          }
          lines.push(this.arrayBoard[this.boardWidth - 1 - x + y + y * this.boardWidth])
        }
        break
      default: 
        break
    }
    return lines
  }

  getForbiddenPosition() {
    var forbiddenPosition
    forbiddenPosition = []
    this.arrayBoard.forEach(cell => {
      if (cell.forbidden === true){
        forbiddenPosition.push({ x : cell.x, y : cell.y })
      }
    })
    return forbiddenPosition
  }

  printArrayBoard(arrayBoard) {
    var num, strings
    strings = ''
    for (num = 0; num < this.boardWidth; num++) {
      strings += this.addStrings(arrayBoard, num)
      strings += `\n`
    }
    console.log(strings)
  }

  addStrings(arrayBoard, num) {
    var strings
    strings = ''
    arrayBoard
    .slice(num * this.boardWidth, (num + 1) * this.boardWidth)
    .forEach(cell => {
      strings += cell.color === 0 ? (cell.forbidden === true ? '*' : '+') : (cell.color === 1 ? '●' : '○')
    })
    return strings
  }

  printTwoDimArrayBoard(twoDimArrayBoard) {
    var strings
    strings = ''
    twoDimArrayBoard.forEach(row => {
      row.forEach(cell => {
        strings += cell.toString(10)
      })
      strings += `\n`
    })
    console.log(strings)
  }
}

export default RenjuEngine


// WEBPACK FOOTER //
// ./src/lib/RenjuEngine.js